<template>
    <div>
        <v-container>
            <v-row no-gutters>
                <v-col :cols="10">
                    <h1 class="headline font-weight-light mb-3">
                        <router-link class="link-a" to="/Permission/Menu"
                            >MANAGE MENU</router-link
                        >
                        / ADD
                    </h1>
                </v-col>
                <v-col :cols="2" class="text-right"> </v-col>
            </v-row>

            <v-form method="post" id="nativeForm" v-model="valid">
                <v-card class="mt-5 pa-7">
                    <v-row>
                        <v-col cols="11" sm="6" md="3">
                            <v-text-field
                                v-model="form.menu_name"
                                label="Main Menu"
                                :rules="mainMenuR"
                                required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="11" sm="6" md="3">
                            <v-text-field
                                v-model="form.menu_icon"
                                label="Icon"
                                :rules="iconR"
                                required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="11" sm="6" md="2">
                            <v-text-field
                                v-model="form.menu_path"
                                label="Path"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="11" sm="5" md="1">
                            <v-text-field
                                v-model="form.menu_no"
                                label="ลำดับเมนู"
                                :rules="menu_noR"
                                required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="1">
                            <v-switch
                                v-model="form.menu_status"
                                :aria-disabled="
                                    form.menu_status === 1 ? true : false
                                "
                                class="ma-1 pa-3"
                                label="Status"
                                value="1"
                            ></v-switch>
                        </v-col>
                    </v-row>

                    <v-row v-for="(n, index) in form.submenu" :key="index">
                        <v-col cols="11" sm="6" md="3">
                            <v-text-field
                                v-model="n.submenu_name"
                                label="Sub Menu"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="11" sm="6" md="3">
                            <v-text-field
                                v-model="n.path"
                                label="Path"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="11" sm="5" md="3">
                            <v-text-field
                                v-model="n.submenu_no"
                                label="ลำดับเมนู"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="1">
                            <v-switch
                                v-model="n.submenu_status"
                                :aria-disabled="
                                    n.submenu_status === 1 ? true : false
                                "
                                class="ma-1 pa-3"
                                label="Status"
                                value="1"
                            ></v-switch>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" v-if="form.submenu.length === num">
                            <v-btn color="warning" fab small @click="plus()">
                                <v-icon small>mdi-plus</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="6" class="text-right">
                            <v-btn
                                color="success"
                                @click="save()"
                                :disabled="!valid"
                                rounded
                            >
                                <v-icon class="mr-1">mdi-content-save</v-icon>
                                Save</v-btn
                            >
                        </v-col>
                    </v-row>
                </v-card>
            </v-form>
        </v-container>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

const url = `${process.env.VUE_APP_ROOT_API}/api/menu/`

export default {
    computed: {
        ...mapState(["snackbar"]),
    },
    mounted() {
        if (this.$route.params.id) {
            this.get_data()
        }
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        async get_data() {
            if (this.$route.params.id) {
                let { data } = await axios.get(url + this.$route.params.id)
                this.form = data[0]
                this.form.submenu.length != ""
                    ? (this.num = this.form.submenu.length)
                    : (this.num = 0)
                // console.log(this.form.submenu)
            }
        },
        async save() {
            if (this.$route.params.id) {
                let { data } = await axios.put(
                    url + this.$route.params.id,
                    this.form
                )
            } else {
                let { data } = await axios.post(url, this.form)
            }
            this.mutatesnackbar()
            this.$root.$router.push({ path: "/Permission/Menu" })
        },
        plus() {
            this.num = this.num + 1
            this.form.submenu.push({
                submenu_name: "",
                submenu_status: "",
                submenu_no: "",
                path: "",
            })
        },
    },
    data() {
        return {
            form: {
                menu_status: 1,
                submenu: [
                    {
                        submenu_name: "",
                        submenu_status: "",
                        submenu_no: "",
                        path: "",
                    },
                ],
            },
            num: 1,
            valid: false,
            mainMenuR: [(v) => !!v || "Main Menu Description is required"],
            iconR: [(v) => !!v || "Icon Description is required"],
            menu_noR: [
                (v) => !!v || "Menu No is required",
                (v) => /^\d+$/.test(v) || "Must be a number",
            ],
        }
    },
}
</script>
